/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Angular es un caso muy especial pues es un framework muy robusto que utiliza es por eso que tiene un CLI superpoderoso que crea la decena de archivos que necesita.`}</p>
    <p>{`Mientras que con React, Vue o Svelte puedes configurar por tu cuenta tu propio proyecto fácilmente para asegurar que puedes personalizar cada detalle de tu aplicación o incluso utilizar las tecnologías directamente desde un CDN en una etiqueta `}<inlineCode parentName="p">{`script`}</inlineCode>{`, hacerlo con Angular sería una tarea algo complicada y 0 recomendada.`}</p>
    <p>{`Sin embargo así luce el archivo `}<inlineCode parentName="p">{`main.ts`}</inlineCode></p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-jsx"
      }}><code parentName="pre" {...{
          "className": "language-jsx"
        }}><span parentName="code" {...{
            "className": "token keyword module"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token imports"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` enableProdMode `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span>{` `}<span parentName="code" {...{
            "className": "token keyword module"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'@angular/core'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword module"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token imports"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` platformBrowserDynamic `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span>{` `}<span parentName="code" {...{
            "className": "token keyword module"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'@angular/platform-browser-dynamic'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// AppModule contiene todas las declaraciones de Componentes`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Y los Modulos de Angular a utilizar etc.`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword module"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token imports"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` `}<span parentName="span" {...{
              "className": "token maybe-class-name"
            }}>{`AppModule`}</span>{` `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span>{` `}<span parentName="code" {...{
            "className": "token keyword module"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'./app/app.module'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Tienes diferentes archivos de configuración segun el entorno`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword module"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token imports"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` environment `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span>{` `}<span parentName="code" {...{
            "className": "token keyword module"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'./environments/environment'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword control-flow"
          }}>{`if`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`environment`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token property-access"
          }}>{`production`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//Corre con caracteristicas especificas de producción`}</span>{`
  `}<span parentName="code" {...{
            "className": "token function"
          }}>{`enableProdMode`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// No tenemos que decirele donde renderizar la aplicación`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Podemos utilzar esta etiqueta directamente en el html:`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// <app-root></app-root>`}</span>{`
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`platformBrowserDynamic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token method function property-access"
          }}>{`bootstrapModule`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token maybe-class-name"
          }}>{`AppModule`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token keyword control-flow"
          }}>{`catch`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}>{`err`}</span>{` `}<span parentName="code" {...{
            "className": "token arrow operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token console class-name"
          }}>{`console`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token method function property-access"
          }}>{`error`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`err`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}</code></pre></div>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;